module.exports = new __parcel__URL__("elf-title-talent-5.8f72a4e4.gif").toString();